<div class="relative h-full" #infotextContainer>
  @let conceptualInfotext = conceptualInfoText$ | async;
  <div class="grid gap-6 pb-6" #generalInfotextContainer>
    <ng-content />
  </div>

  @if (conceptualInfotext) {
    <div class="grid gap-6 mt-6">
      <ui-infotext-item [infotext]="conceptualInfotext" />
    </div>
  }
</div>
